<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <Overlayscreen :visible="isLoading">
    <div class="message flex h-screen items-center justify-center">
      <div>
        <div class="text-center">Loading..</div>
      </div>
    </div>
  </Overlayscreen>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, useRouter, type RouteLocation } from 'vue-router'
import { useSharedWorker } from '@/composables/useSharedworker'
import Overlayscreen from '@/components/OverlayScreen.vue'

const router = useRouter()
const route = useRoute()
const worker = useSharedWorker()

const isLoading = ref(false)

const loading = (() => {
  const show = () => (isLoading.value = true)
  const hide = () => (isLoading.value = false)
  return { show, hide }
})()

const splitToRoute = (fullPath: string) =>
  fullPath.split('//').map((url) => {
    if (!url.startsWith('/')) {
      url = '/' + url
    }
    return router.resolve(url)
  })

// Page スタックの一番上が、DBを要求していれば待つ
const isRequireDB = (routes: RouteLocation[]): boolean => {
  return routes[routes.length - 1].meta.requiresDB === true
}

watch(
  () => route.fullPath,
  async (fullPath) => {
    const stacks = splitToRoute(fullPath)
    if (!isRequireDB(stacks)) {
      loading.hide()
      return
    }
    if ((await worker.waitState()) === 'SyncRunning') return
    loading.show()
    await worker.waitState('SyncRunning')
    loading.hide()
  },
  { immediate: true }
)
</script>

<style scoped>
.message {
  background: rgba(255, 255, 255, 0);
  transition: all 0.5s ease-in-out 0s;
}
</style>
